// extracted by mini-css-extract-plugin
export default {"vac":"style_vac__5QaVc","responsibilities":"style_responsibilities__TOr-J","requirements":"style_requirements__IQ+24"};